export default __webpack_public_path__ + "static/media/calendar__icon.baf23e6b.svg";